import { Site } from '@envato/foundation-types'

const experimentConfig = {
  categoryRedesignTFPhase4Experiment: {
    experimentId: 'R_qk8EJ2Qzuj9y78ysRAjA',
    running: true,
    loadingCover: true,
    sites: [Site.themeforest],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      }
    }
  },
  categoryRedesignVHPhase2Experiment: {
    experimentId: 'whz7LWAXRE2MLh7mYT-aZw',
    running: true,
    loadingCover: true,
    sites: [Site.videohive],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      }
    }
  },
  authorDiscountingItemsPhase1: {
    experimentId: 'kT4ZPZugQPSUM-qZH6fqhw',
    running: false,
    loadingCover: true,
    sites: [Site.themeforest],
    variants: {
      0: {
        showPromoItemsBlock: false,
        showWasNowPricing: false
      },
      1: {
        showPromoItemsBlock: false,
        showWasNowPricing: false
      },
      2: {
        showPromoItemsBlock: true,
        showWasNowPricing: false
      },
      3: {
        showPromoItemsBlock: true,
        showWasNowPricing: false
      },
      4: {
        showPromoItemsBlock: true,
        showWasNowPricing: true
      },
      5: {
        showPromoItemsBlock: true,
        showWasNowPricing: true
      }
    }
  }
}

export default experimentConfig
